import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';

type Props = {
  // 本文の領域の中で使うときは、画面の高さいっぱいに広げるとフッターが押し出されるので小さくする
  minHeight?: string;
};

const LoadingScreen: React.FC<Props> = ({ minHeight = '100vh' }) => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight }}
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};

export default LoadingScreen;
